<template>
  <div class="container">
    <!-- 顶部保持不变 -->
    <div class="header">
      <div class="header-left">
        <button class="btn-index" @click="goToPage('/')">{{ websiteName }}</button>
      </div>
      <div class="header-right">
        <ThemeSwitcher class="header-item" />
      </div>
    </div>

    <div class="main">
      <router-view />
    </div>

    <!-- 底部新增按钮 + 版权 -->
    <div class="footer">
      <div class="footer-actions">
        <button class="footer-btn" @click="goToPage('/subscribe')">订阅</button>
        <button class="footer-btn" @click="goToPage('/guestbook')">留言</button>
      </div>
      <p class="footer-copy">focus x world © 2025 版权所有 · 访问次数 {{ newsPv ?? '…' }}</p>
    </div>
  </div>
</template>

<script setup>
import ThemeSwitcher from './views/ThemeSwitcher.vue'
import { useRouter, useRoute } from 'vue-router'
import { ref, watch, onMounted } from 'vue'

const websiteName = 'Focus X World'
const router = useRouter()
const route = useRoute()
const goToPage = (path) => router.push(path)

// Vercount 统计 AllNews（/news）页面的访问次数
// POST 会 +1，只在真正访问 /news 时调用；GET 只读，其他页面仅显示不计数
const newsPv = ref(null)
let lastPath = route.path

async function updateNewsCount() {
  const url = window.location.origin + '/news'
  try {
    let res
    if (route.path === '/news') {
      res = await fetch('https://events.vercount.one/api/v2/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url, isNewUv: false })
      })
    } else {
      res = await fetch('https://events.vercount.one/api/v2/log?url=' + encodeURIComponent(url))
    }
    const json = await res.json()
    if (json.status === 'success' && json.data) {
      newsPv.value = json.data.page_pv
    }
  } catch (e) {
    // 请求失败保持上次的值
  }
}

watch(
  () => route.path,
  async (path) => {
    if (path === '/news') {
      if (lastPath !== '/news') await updateNewsCount() // 进入 /news 才 +1
    } else {
      await updateNewsCount() // 其他页面只读刷新
    }
    lastPath = path
  }
)

onMounted(() => {
  updateNewsCount()
})
</script>

<style>
.container {
  margin: 0 auto;
  padding: 10px 0;
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

/* —— 顶部 & 主体样式不变 —— */
.header {
  height: 10%;
  width: 100%;
  display: flex;
  align-items: center;
}
.header-left { flex: 70%; text-align: left; }
.header-right { flex: 1; text-align: right; display: flex; justify-content: flex-end; }
.btn-index { border: none; background: transparent; color: var(--color); font-size: 26px; font-weight: 700; letter-spacing: 1px; cursor: pointer;}
.btn-index:hover { opacity: .8; }
.header-item { margin: 5px; }

.main {
  height: 80%;
  width: 100%;
  margin: auto;

  /* 关键：让子元素能 100% 撑满 */
  display: flex;          /* 弹性布局 */
  flex-direction: column; /* 垂直排列 */
}

/* —— 底部改为上下两行 —— */
.footer {
  height: 10%;               /* 整体仍占 10% */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  letter-spacing: .5px;
  opacity: .6;
}

.footer-actions {
  display: flex;
  gap: 12px;                 /* 按钮间距 */
  margin-bottom: 4px;        /* 与版权行的小间隔 */
}

.footer-btn {
  border: 1px solid var(--color);
  background: transparent;
  color: var(--color);
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.footer-btn:hover {
  opacity: .8;
  transform: translateY(-1px);
}

.footer-copy {
  margin: 0;
  font-size: 12px;
}
</style>